import React from "react"
import Layout from "../components/Layout"
import Banner from "../img/notfound.inline.svg"
import { Link } from "gatsby"
import "../styles/pages/notfound.scss"

const NotFoundPage: React.FC<any> = () => {
  return (
    <Layout title="404 Not Found" withFooter={false}>
      <div id="notfound-page">
        <div className="info">
          <h1 className="font-head font-lg">Page was lost</h1>
          <p className="font-body font-md">
            This page isn&apos;t available
            <Link to="/" className="font-body font-md">
              go back Home
            </Link>
          </p>
        </div>
        <Banner />
      </div>
    </Layout>
  )
}

export default NotFoundPage
